import { Map } from 'immutable';


const initialState = Map({
  sendEmailPending: false,
  sendEmailError: null,
  sendEmailSuccess: false
});

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js